export default function ElementProfiles() {
  document.querySelectorAll('.profile__open').forEach(profileOpen => {
    profileOpen.addEventListener('click', () => {
      const dialog = document.getElementById(
        profileOpen.getAttribute('aria-controls')
      );
      dialog.showModal();
    });
  });
  document.querySelectorAll('.profile__close').forEach(profileClose => {
    profileClose.addEventListener('click', () => {
      const dialog = document.getElementById(
        profileClose.getAttribute('aria-controls')
      );
      dialog.close();
    });
  });
}
